import PocketBase from 'pocketbase';

const PB_URL = import.meta.env.VITE_PB_URL || 'https://api.lifefocus.agency';

export const pb = new PocketBase(PB_URL);

// Persistir auth en localStorage automáticamente
pb.authStore.onChange(() => {
  // PocketBase ya persiste por default en localStorage,
  // este hook está para futuros side-effects (ej. broadcast a tabs).
});

export type AuthRecord = {
  id: string;
  email: string;
  display_name?: string;
  role: 'superadmin' | 'client_admin' | 'sales_rep';
  tenant?: string;
  avatar?: string;
  verified: boolean;
};

export function isLoggedIn(): boolean {
  return pb.authStore.isValid;
}

export function currentUser(): AuthRecord | null {
  if (!pb.authStore.record) return null;
  return pb.authStore.record as unknown as AuthRecord;
}
